import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import i18n from 'i18n-js';
import Layout from 'components/Layout';
import { useParams } from 'react-router-dom';
import { CreditTypeDetailsWidget } from 'components/CreditTypes';
import Logs from 'components/Logs';
import Comments from 'components/Comments';

const CreditTypeDetails = () => {
  const { id } = useParams();

  return (
    <Layout title={i18n.t('credit_types.title')}>
      <Grid container spacing={2} p={1}>
        <Grid item spacing={2}>
          <Typography variant="h6" gutterBottom>
            <Box fontWeight="fontWeightBold" fontSize={24} my={1}>
              {i18n.t('credit_types.details_title', { id: id || '--' })}
            </Box>
          </Typography>
        </Grid>
        <Grid container size={12}>
          <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
            <CreditTypeDetailsWidget id={id} />
          </Grid>
          <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
            <Comments type="invoice_item_type" id={+id} />
          </Grid>
          <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
            <Logs
              title={i18n.t('credit_types.logs')}
              targetType={'InvoiceItemType'}
              targetId={+id}
              height={400}
            />
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
};

export { CreditTypeDetails };
